export default __webpack_public_path__ + "static/Presentations-a98794bfc53c41a5fdaff648d8b0c717.png";